import Grid from '@mui/material/Grid';
import MouthTongueText from './MouthTongueText';
import MicroButtonGroup from '../Tongue/TongueAux/MicroButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import GetTongue from './Profiling/GetTongue';



export default function MouthSectionTongue() {

    
    return (

     <SectionStructure
        
        sectiontext=    { <MouthTongueText /> }
        sectiondiagroup=    { <MicroButtonGroup />} 

        sectioncards=  {
        
            <Grid container spacing={0}>
                    <Grid size={{xs:12, xl:12}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}> <GetTongue /></Grid>
                     <Grid size={{xs:12, xl:6}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start'}}>   </Grid>
                </Grid>        
        }

    />

    )
}